import { VariantLogoProps } from '.';

export const factor = 100 / 296;

export const Component = ({
	width = 'auto',
	height = 'auto',
	fill,
	...props
}: VariantLogoProps) => (
	<svg
		width={296}
		height={100}
		viewBox="0 0 296 100"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		style={{
			width,
			height,
		}}
		{...props}
	>
		<path
			d="M31.975 33.1042C23.2786 33.1042 16.25 40.0916 16.25 48.5682C16.25 57.2738 23.2786 64.0321 31.975 64.0321C41.3863 64.0321 48.4149 57.2738 48.4149 48.5682C48.4149 40.0916 41.2671 33.1042 31.975 33.1042ZM31.8559 100C18.156 100 8.62567 94.9599 2.31181 86.2543L14.2248 78.4651C17.9178 83.3906 23.7551 86.5979 31.6177 86.5979C41.8628 86.5979 48.1766 82.4742 48.1766 74.1123V72.5086C43.7689 76.0596 37.6933 77.8923 30.5455 77.8923C14.2248 77.8923 0.16748 65.1776 0.16748 48.4536C0.16748 31.8442 14.2248 18.7858 30.5455 18.7858C38.6463 18.7858 44.6028 21.3058 48.1766 24.055V19.7022H64.6165V72.7377C64.6165 87.858 52.9418 100 31.8559 100ZM87.7276 14.6621H71.1686V0H87.7276V14.6621ZM87.7276 78.4651H71.1686V19.7022H87.7276V78.4651ZM118.82 19.7022H133.831V33.9061H118.82V57.5029C118.82 62.7721 121.322 64.8339 126.921 64.8339H133.831V78.4651H125.73C109.528 78.4651 102.261 71.4777 102.261 58.3047V33.9061H93.4458V19.7022H102.261V4.5819H118.82V19.7022ZM200.067 65.8648C194.11 74.4559 184.699 79.8396 171.118 79.8396C151.581 79.8396 138.953 66.6667 138.953 49.2554C138.953 32.3024 152.058 18.5567 171.237 18.5567C190.536 18.5567 202.211 31.386 202.211 48.4536C202.211 50.7446 201.973 53.7228 201.973 54.0664H155.274C157.061 61.512 162.898 66.323 171.476 66.323C178.862 66.323 184.222 63.2302 187.677 58.5338L200.067 65.8648ZM171.118 31.6151C163.375 31.6151 158.014 35.6243 155.87 42.268H185.533C183.746 35.1661 177.789 31.6151 171.118 31.6151ZM239.141 33.5624C230.087 33.5624 223.059 40.6644 223.059 49.37C223.059 58.1901 230.087 65.1776 239.141 65.1776C248.672 65.1776 255.819 58.1901 255.819 49.37C255.819 40.6644 248.433 33.5624 239.141 33.5624ZM255.581 78.4651V74.1123C251.292 77.3196 244.621 79.2669 237.712 79.2669C221.033 79.2669 206.857 66.323 206.857 49.37C206.857 32.417 221.033 19.1294 237.712 19.1294C244.621 19.1294 251.292 21.1913 255.581 24.3986V19.7022H272.14V78.4651H255.581ZM295.37 14.6621H278.811V0H295.37V14.6621ZM295.37 78.4651H278.811V19.7022H295.37V78.4651Z"
			fill={fill}
		/>
	</svg>
);
